import React from 'react';
import { cn } from '@/lib/utils';

export function Card({ className = '', children, ...props }) {
  return (
    <div className={cn('card-hard p-5', className)} {...props}>
      {children}
    </div>
  );
}

export function CardSm({ className = '', children, ...props }) {
  return (
    <div className={cn('card-hard-sm p-4', className)} {...props}>
      {children}
    </div>
  );
}

export function Label({ className = '', children, ...props }) {
  return (
    <label
      className={cn(
        'block font-display text-xs font-bold uppercase tracking-widest text-carbon-soft mb-2',
        className
      )}
      {...props}
    >
      {children}
    </label>
  );
}

export function Input({ className = '', ...props }) {
  return <input className={cn('input-rugged', className)} {...props} />;
}

export function Textarea({ className = '', ...props }) {
  return <textarea className={cn('input-rugged min-h-[80px] font-sans', className)} {...props} />;
}

export function Select({ className = '', children, ...props }) {
  return (
    <select
      className={cn('input-rugged appearance-none font-sans pr-8', className)}
      {...props}
    >
      {children}
    </select>
  );
}

export function Stepper({ value, onChange, min = 0, step = 0.1, unit = '', testid }) {
  const dec = () => onChange(Math.max(min, +(Number(value) - step).toFixed(2)));
  const inc = () => onChange(+(Number(value) + step).toFixed(2));
  return (
    <div className="flex items-stretch border-2 border-carbon" data-testid={testid}>
      <button
        type="button"
        onClick={dec}
        className="w-14 bg-surface-alt text-2xl font-bold border-r-2 border-carbon active:bg-carbon active:text-canvas"
        data-testid={testid ? `${testid}-dec` : undefined}
      >−</button>
      <input
        type="number"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
        className="flex-1 text-center text-2xl mono font-semibold bg-white outline-none"
        step={step}
      />
      <button
        type="button"
        onClick={inc}
        className="w-14 bg-surface-alt text-2xl font-bold border-l-2 border-carbon active:bg-carbon active:text-canvas"
        data-testid={testid ? `${testid}-inc` : undefined}
      >+</button>
      {unit && (
        <span className="px-3 flex items-center bg-carbon text-canvas mono text-sm font-semibold">
          {unit}
        </span>
      )}
    </div>
  );
}

export function Pill({ color = '#1A1D1A', children, className = '' }) {
  return (
    <span className={cn('pill', className)} style={{ borderColor: color, color }}>
      <span className="inline-block w-2 h-2" style={{ background: color }} />
      {children}
    </span>
  );
}
